// removed by extract-text-webpack-plugin
module.exports = {"save-modal":"save-modal__1mniO","sm-content":"sm-content__1JsCA","sm-header":"sm-header__pTWu4","title":"title__2RT69","sm-component":"sm-component__3eWa1","sm-footer":"sm-footer__37xtt","sm-open":"sm-open__kHuRq","modal-wrapper":"modal-wrapper__2e_Ms","scroll-x":"scroll-x__3hAFK","footer-popup":"footer-popup__1W2Ou","full-screen":"full-screen__21QwN","back":"back__3Nj64"};


//////////////////
// WEBPACK FOOTER
// ./styles/modal.scss
// module id = 1105
// module chunks = 68